module.exports = __webpack_public_path__ + "static/media/napolean.3a0c9143.JPG";